import React from "react";
import { useAgents } from "../../list-manager/api";
import { Typography, Stack, Chip, Avatar } from "@mui/material";
import { limitString } from "../../../../../util";
import AgentChip from "./AgentChip";

type AgentListProps = {
  selectedAgent: Agent | null | undefined;
  onSelectAgent: (v: Agent) => void;
};

export default function AgentsList({
  selectedAgent,
  onSelectAgent,
}: AgentListProps) {
  const { data, isLoading } = useAgents();

  if (isLoading) return <Typography>Loading...</Typography>;
  if (!data) return <Typography>No Agents Found</Typography>;

  return (
    <Stack gap={1} padding={2} paddingLeft={0}>
      {data.map((agent) => (
        <AgentChip
          onClick={onSelectAgent}
          isSelected={selectedAgent?.id === agent.id}
          agent={agent}
          formatter={(email: string) => {
            return limitString(email, 12);
          }}
        />
      ))}
    </Stack>
  );
}
